'use strict';

import { forEach, isElement, debounce } from 'lodash';
import containerManager from '../../01-helpers/filter-context/container-manager';
import { subscribe, publish } from '../../01-helpers/event-manager';
import {
	TEETIMES_UNAVAILABLE,
	TEETIMES_AVAILABLE,
	TAB_ACTIVATED
} from '../../02-const/event-names';

/* ========================================================================== */

const moduleName = 'tab',
	attributeNames = {
		key: `data-${moduleName}-key`
	},
	selectors = {
		base: `.js-${moduleName}`,
		trigger: `.js-${moduleName}__trigger`,
		container: `.js-${moduleName}__container`,
		content: `.js-${moduleName}__content`,
		radio: 'input[type="radio"]'
	},
	className = {
		selected: 'selected'
	};

/* ========================================================================== */

function bindEvents() {
	// get all tab-triggers
	const tabs = this.baseElement.querySelectorAll(selectors.trigger);
	this.clickHandler = (event) => this._onClickHandler(event);

	// add listener to tab-triggers
	forEach(tabs, (tab) => {
		tab.addEventListener('click', this.clickHandler, false);
	});

	subscribe(TEETIMES_UNAVAILABLE, (event) => this._disable(event.detail));
	subscribe(TEETIMES_AVAILABLE, (event) => this._enable(event.detail));
}

export class Tab {
	constructor(baseElement) {
		if (!isElement(baseElement)) {
			return false;
		}

		this.baseElement = baseElement;
		this.filterContext = containerManager.getContainer();
		this.shouldRefresh = false;

		bindEvents.call(this);
		this._setup();
	}

	_setup() {
		const trigger = this.baseElement.querySelector(selectors.trigger);

		trigger.querySelector(selectors.radio).checked = true;

		this.selectedValue = trigger.dataset.loop;
		this._showContent(trigger.dataset.tabId);

		this._setInitialTab();
	}

	/* ====================================================================== */

	get key() {
		return this.baseElement.getAttribute(attributeNames.key);
	}

	get holes() {
		return 'holes';
	}

	set selectedValue(value) {
		this.filterContext.update(
			{
				[this.key]: value
			},
			{ refresh: this.shouldRefresh }
		);
	}

	/* ====================================================================== */

	_disable(tabElement) {
		const radioInputElement = tabElement.querySelector(selectors.radio);

		if (!radioInputElement) {
			return;
		}

		tabElement.classList.add(className.disable);
		radioInputElement.disabled = true;
	}

	_enable(tabElement) {
		const radioInputElement = tabElement.querySelector(selectors.radio);

		if (!radioInputElement) {
			return;
		}

		tabElement.classList.remove(className.disable);
		radioInputElement.disabled = false;
	}

	/* ====================================================================== */

	_onClickHandler(evt) {
		evt.stopPropagation();
		evt.preventDefault();
		// remove all active states from tabs.
		const currentTrigger = evt.currentTarget;
		const tabId = currentTrigger.dataset.tabId;
		currentTrigger.querySelector(selectors.radio).checked = true;

		this.shouldRefresh = true;
		this.selectedValue = currentTrigger.dataset.loop;
		this._showContent(tabId);
	}

	_showContent(tabId) {
		const tabContainers = this.baseElement.querySelectorAll(selectors.content);

		forEach(tabContainers, (container) =>
			container.classList.remove(className.selected)
		);

		const tabContent = this.baseElement.querySelector(`#${tabId}`);

		tabContent.classList.add(className.selected);
	}

	_setInitialTab() {
		const holes = this.holes;

		const valueToCheck = 
			holes in this.filterContext.state
				? this.filterContext.state[holes] : '';

		if (!valueToCheck) {
			return;
		}

		
		//switch to correct tab, and show correct content

		//get all tabs
		const tabs = this.baseElement.querySelectorAll(selectors.trigger);
		let selectedTab = tabs[0];

		forEach(tabs, (tab) => {
			// check if 
			if (tab.dataset.holes.includes(valueToCheck)) {
				selectedTab = tab;
				return false;
			}
		});

		const tabId = selectedTab.dataset.tabId;
		selectedTab.querySelector(selectors.radio).checked = true;

		this.selectedValue = selectedTab.dataset.loop;
		this._showContent(tabId);

		publish(TAB_ACTIVATED);
	}
}

const initTab = () => {
	forEach(document.querySelectorAll(selectors.base), (tabElement) => {
		new Tab(tabElement);
	});
};

initTab();
